module.exports = __webpack_public_path__ + "static/media/6.8d1f678f.png";